import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { ProductDetailService } from '@features/product-detail/product-detail.service';
import { SortPropertiesPipe } from '@shared/product-details-pipes/sort-properties.pipe';
import { RemoveDuplicatePropsPipe } from '@shared/product-details-pipes/remove-duplicate-props.pipe';
import { NormalizePropertiesPipe } from '@shared/product-details-pipes/normalize-properties.pipe';
import { MatchColorPipe } from '@shared/product-details-pipes/match-color.pipe';
import { ColorStylePipe } from '@shared/product-details-pipes/color-style.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, KeyValuePipe, NgClass, NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-product-specifications',
    templateUrl: './product-specifications.component.html',
    styleUrls: ['./product-specifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        NgTemplateOutlet,
        AsyncPipe,
        KeyValuePipe,
        TranslateModule,
        TranslateSafePipe,
        ColorStylePipe,
        MatchColorPipe,
        NormalizePropertiesPipe,
        RemoveDuplicatePropsPipe,
        SortPropertiesPipe
]
})
export class ProductSpecificationsComponent {
    @Input()
    showRelatedSpecifications: boolean = false;

    constructor(
        public readonly settingsService: SettingsService,
        public readonly productDetailService: ProductDetailService
    ) {}

    public returnZero() {
        return 0;
    }
}
